import { useLocation } from "react-router-dom";

export const useServiceMode = () => {
    const { pathname } = useLocation();
    return pathname.startsWith("/delivery") ? "DELIVERY" : "LOCAL";
};